import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Translate} from "app/services/translate";
import {COUNTRY} from "app/model/calculator";
import {Select} from "./select/select";
import {SelectItem} from "./select/options/item/item";
import {availableCountries} from "app/static/countries";

export class CountrySelect extends Component {
    static get propTypes() {
        return {
            settings: PropTypes.object,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            countries: PropTypes.array,
            onChange: PropTypes.func,
        }
    }

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this._shouldBeDisabled = this._shouldBeDisabled.bind(this);
    }

    handleChange(name, value) {
        this.setState({value});
        this.props.onChange(value, name);
    }

    /** @private */
    _renderOptionsTemplate(countries) {
        return countries.map((country) => (
            <SelectItem
                key={country}
                value={country}
                flag={country}
                suggested={availableCountries.find((c) => c.code === country && c.suggested)}
                content={Translate(`country_${country.toLowerCase()}_name`)}/>
        ));
    }

    /** @private */
    _shouldBeDisabled() {
        const {settings, type} = this.props;

        if (settings.disableCountryOut && type === COUNTRY.OUT) {
            return settings.disableCountryOut;
        }

        return settings.disableDirections;
    }

    render() {
        const {countries, value, type, label} = this.props;
        const options = this._renderOptionsTemplate(countries);
        const disabled = this._shouldBeDisabled();

        return value && (
            <div>
                <Select
                    name={type}
                    label={label}
                    value={value}
                    options={options}
                    disabled={disabled}
                    onChange={this.handleChange}/>
            </div>
        )
    }
}
